import React, { useEffect } from 'react';
import Loading from '../../components/Loading';
import Dashboard from './Dashboard';
import useFetch from '../../hooks/useFetch';
import { useIsAdmin } from '../../hooks/useIsAdmin';
import { useSchoolRole } from '../../hooks/useSchoolRole';

const DashboardContainer = () => {
  const { isAdmin, loading: adminLoading } = useIsAdmin();
  const { role, loading: roleLoading } = useSchoolRole();
  const { data, parentData, loading } = useFetch();

  // ¿El padre ya tiene un aprendiz? (data queda undefined si no hay hijo con username)
  const noLearner = !loading && !(data && data.username);

  // El Dashboard es de Padre CON aprendiz. Los roles institucionales/admin rebotan
  // a su panel; el padre sin aprendiz aún va al onboarding guiado.
  useEffect(() => {
    if (adminLoading || roleLoading) return;
    if (isAdmin) window.location.replace('/admin/payments');
    else if (role === 'escuela') window.location.replace('/school');
    else if (role === 'maestro') window.location.replace('/teacher');
    else if (noLearner) window.location.replace('/onboarding');
  }, [isAdmin, role, adminLoading, roleLoading, noLearner]);

  const values = {
    logged : true,
    learner : data,
    parent : parentData
}

  // Mientras resolvemos el rol, o si es institucional/admin (en redirección), loader.
  if (adminLoading || roleLoading || isAdmin || role === 'escuela' || role === 'maestro')
    return <Loading/>

  if (loading)
    return <Loading/>

  // Padre sin aprendiz: en redirección a /onboarding.
  if (noLearner)
    return <Loading/>

  return <Dashboard values={values}/>
  
  /* (
    <div className='max-w-[600px] mx-auto my-16 p-4'>
      <h1 className='text-2xl font-bold py-4'>Account</h1>
      <p>User Email: {user && user.email}</p>

      <button onClick={handleLogout} className='border px-6 py-2 my-4'>
        Logout
      </button>
    </div>
  ); */
};

export default DashboardContainer;